module.exports = __webpack_public_path__ + "img/Blog-Image.c5828f4a.png";